import { connect } from 'react-redux'

import { doFetchCustomProfile } from 'ducks/inAppCards/customProfile'
import { selectAccountPrefersUnsafeCustomProfile } from 'selectors/app'
import View from './view'
import withCardDataLoading from '../withCardDataLoading'

const KEY = 'custom-profile'
const select = state => ({
  hardRefreshOnReload: true,
  key: KEY,
  openStateKey: KEY,
  safe: !selectAccountPrefersUnsafeCustomProfile(state),
  title: 'Custom Profile',
})

const performFactory = (initialState, initialOwnProps) => {
  const { customerId, id: cardId } = initialOwnProps

  return dispatch => ({
    load: opts => dispatch(doFetchCustomProfile(customerId, cardId, opts)),
  })
}

export default connect(select, performFactory)(withCardDataLoading(View))
